import React from 'react';
import { Virtuoso } from 'react-virtuoso';
import { lang } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';
import { MCText, Spinner } from '../basic';

const MCVirtuoso = ({ model, components, ...props }) => {
  model.use();

  const items = model.items();
  const loading = model.refreshing();
  const searchQuery = model.listInput('search');
  const noResults = model.noResults();

  return (
    <Virtuoso
      style={{ flexGrow: 1 }}
      data={items}
      components={{
        Footer: () =>
          (noResults || loading) && (
            <>
              {noResults && !searchQuery && (
                <MCText size={18} textLight weight={500} style={{ textAlign: 'center' }}>
                  {lang.t(LANG_CONST.text.no_results_yet)}
                </MCText>
              )}
              {noResults && searchQuery && (
                <MCText size={18} textLight weight={500} style={{ textAlign: 'center' }}>
                  {lang.t(LANG_CONST.text.nothing_found)}
                </MCText>
              )}
              <div style={{ textAlign: 'center', paddingBottom: 20, flex: 1 }}>
                {loading && <Spinner />}
              </div>
            </>
          ),
        ...components
      }}
      endReached={() => {
        if (model.hasMore() && !model.refreshing()) model.loadMore();
      }}
      {...props}
    />
  );
};


MCVirtuoso.displayName = 'MCVirtuoso';

export default MCVirtuoso;
